import { createSlice } from "@reduxjs/toolkit";

const iomPendingCount = createSlice({
    name: "iomPendingCount",
    initialState: {
        count: 0,
    },
    reducers: {
        pendingCount: (state, action) => {
            state.count = action.payload
        }
    },
});

export const { pendingCount } = iomPendingCount.actions;
export default iomPendingCount.reducer;